import { BaseModel } from "./BaseModel";
import IErrorData from "../server/data/errorData";

class ErrorModel extends BaseModel<IErrorData> {
    public errorCode: number = -1;
    public errorMessage: string = "";
    public critical: boolean = false;
    public rawError: any;

    public cleanUp() {
        // if ( !this.critical ) {
            this.errorMessage = "";
            this.errorCode = -1;
            this.critical = false;
        // }
    }

    public hasError(): boolean {
        return this.errorCode >= 0;
    }
}


export default new ErrorModel();